import Connector, { takeQuery } from '../../agent';
import types from './types';

const Persons = {
  getPersonAutocompleteList: ({ name, isNotMissingLmsCourses, showPersonalData }) => {
    return Connector.api.get('/persons/autocomplete', false, {name, isNotMissingLmsCourses}).then(result => {
      result.data.forEach(name => {
        if(showPersonalData === false){
          name['privateValue']=name.name;
        }
        name.name = showPersonalData === false ? name.name.replace(/[a-z]/g, 'x') : name.name

      });
      return result;
    });
  }
};

const personSagas = [
  takeQuery(types.GET_PERSON_AUTOCOMPLETE_LIST, Persons.getPersonAutocompleteList)
];

export default personSagas;
